<ng-container *ngIf="!hasLoaded && !hasFailed">
  <div id="app-loading" *ngIf="!isInline; else inlineBlock">
    <mat-spinner *ngIf="isCircle; else horizontalBlock" [diameter]="diameter" [style]="spinnerCss"></mat-spinner>
    <ng-template #horizontalBlock>
      <mat-progress-bar mode="indeterminate" [style]="spinnerCss"></mat-progress-bar>
    </ng-template>
  </div>
  <ng-template #inlineBlock>
    <span id="app-loading">
      <mat-spinner [diameter]="diameter" class="inline" [style]="spinnerCss"></mat-spinner>
    </span>
  </ng-template>
</ng-container>

<div *ngIf="hasFailed" class="error-container">
  <div style="font-size: large;">
    <mat-icon class="amber-text text-darken-4 align-middle">error_outline</mat-icon>
    {{ failTitle | translate:locale.language }}
  </div>
  <div *ngIf="!hideRetry && retryClicked.observers.length" style="margin-top: 0.5rem;">
    <button mat-raised-button color="primary" (click)="onRetry()">{{ retryText | translate:locale.language }}</button>
  </div>
</div>